<style scoped>
</style>

<template>
  <div style="background:#fff;padding:15px;">
    <Breadcrumb style="margin-left:15px;">
        <BreadcrumbItem to="/vreleasemanage">首页</BreadcrumbItem>
        <BreadcrumbItem >申请信息</BreadcrumbItem>
    </Breadcrumb>
    <Form :model="formItem" :label-width="80" style="margin-top:20px;">
        <FormItem :label-width="150" label="组件名称：" >
            {{ formItem.name }}
        </FormItem>
        <FormItem :label-width="150" label="版本号：" >
            {{ formItem.version }}
        </FormItem>
        <FormItem :label-width="150" label="构建号：" >
            {{ formItem.buildcode }}
        </FormItem>
        <FormItem :label-width="150" label="版本类型：" >
            <Tag v-if="formItem.type==1" color="green" >正式版本</Tag>
            <Tag v-if="formItem.type==2" color="orange" >sp版本</Tag>
        </FormItem>
        <FormItem :label-width="150" label="更新内容：" >
            <div v-for="(item, index) in formItem.contents" v-bind:key="index">
                {{ index+1 }}、
                <Tag v-if="item.type==0" color="green" >新增</Tag>
                <Tag v-if="item.type==1" color="error" >修复</Tag>
                <Tag v-if="item.type==2" color="orange" >优化</Tag>
                {{ item.description }}
            </div>
        </FormItem>
    </Form>

    <Steps :current="formItem.step" direction="vertical" style="padding:0px 80px; margin-top:44px; margin-bottom: 50px;width:700px;">
            <template v-for="(it, index) in testContents" >
                <Step   v-if="(index < 4)"
                        :key="index" 
                        :title="it" >
                    <template slot="content">
                        <span v-if="index == 0">
                             待审核
                        </span>
                        <span v-else-if="index < formItem.step">
                            <Alert type="success" show-icon>审核通过</Alert>
                        </span>
                        <span v-else-if="index == formItem.step">
                                <Form v-if="(isDeveloper)&&(examines.info.state == -1)&&(formItem.state == 1)">
                                    <FormItem  >
                                        <Upload
                                                ref="uploadAttacher"
                                                :action="filePushUpload.uploadurl"
                                                :data="filePushUpload.fileUploadParams"
                                                :headers="filePushUpload.headers"
                                                :show-upload-list="true"
                                                :before-upload="handleBeforeUpload"
                                                :on-success="onAttachUploadSuccess"
                                                :on-error="onAttachUploadError" >
                                                <Button icon="ios-cloud-upload-outline">附件上传</Button>
                                            </Upload>
                                    </FormItem>
                                    <FormItem label="备注："  >
                                        <Input v-model="examineForm.mark" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="备注描述..."></Input>
                                    </FormItem>
                                    <FormItem   >
                                        <Button @click="saveAndProcess"  :disabled="saveBtnIsDisabled"  type="primary">{{ saveBtnText }}</Button>
                                    </FormItem>
                                </Form>
                                <div v-else-if="!isDeveloper">
                                    <Alert  type="warning" show-icon>
                                            待提交审核
                                    </Alert>
                                </div>
                                <div v-if="(examines.info.state == 0)&&(formItem.state == 2)">
                                    <Alert  type="warning" show-icon>
                                            审核中
                                    </Alert>
                                    <Form v-if="examines.info.type != 0">
                                        <FormItem label="附件："  >
                                            <a
                                                :href="attachurl"
                                                target="_blank"
                                            >下载</a>
                                        </FormItem>
                                        <FormItem label="备注："  >
                                                {{ examines.info.mark }}
                                        </FormItem>
                                    </Form>
                                </div>
                                
                                <template v-if="examines.info.state == 2">
                                    <Alert v-for="(jt, jndex) in examines.reasons" :key="jndex" type="error" show-icon>
                                        {{ jt.reason }}
                                    </Alert>
                                </template>
                        </span>
                        <span v-else >
                            未开始
                        </span>
                    </template>
                </Step>
                <Step
                     v-if="(index >= 4) && (formItem.type != 2)"
                        :key="index" 
                        :title="it">
                        <template slot="content">
                            <span v-if="index < formItem.step">
                                <Alert type="success" show-icon>审核通过</Alert>
                            </span>
                            <span v-else-if="index == formItem.step">
                                <Form v-if="(isDeveloper)&&(examines.info.state == -1)&&(formItem.state == 1)">
                                    <FormItem  >
                                        <Upload
                                                ref="uploadAttacher"
                                                :action="filePushUpload.uploadurl"
                                                :data="filePushUpload.fileUploadParams"
                                                :headers="filePushUpload.headers"
                                                :show-upload-list="true"
                                                :before-upload="handleBeforeUpload"
                                                :on-success="onAttachUploadSuccess"
                                                :on-error="onAttachUploadError" >
                                                <Button icon="ios-cloud-upload-outline">附件上传</Button>
                                            </Upload>
                                    </FormItem>
                                    <FormItem label="备注："  >
                                        <Input v-model="examineForm.mark" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="备注描述..."></Input>
                                    </FormItem>
                                    <FormItem   >
                                        <Button @click="saveAndProcess"  :disabled="saveBtnIsDisabled"  type="primary">{{ saveBtnText }}</Button>
                                    </FormItem>
                                </Form>
                                <div v-else-if="!isDeveloper">
                                    <Alert  type="warning" show-icon>
                                            待提交审核
                                    </Alert>
                                </div>
                                <div v-if="(examines.info.state == 0)&&(formItem.state == 2)">
                                    <Alert  type="warning" show-icon>
                                            审核中
                                    </Alert>
                                    <Form v-if="examines.info.type != 0">
                                        <FormItem label="附件："  >
                                            <a
                                                :href="attachurl"
                                                target="_blank"
                                            >下载</a>
                                        </FormItem>
                                        <FormItem label="备注："  >
                                                {{ examines.info.mark }}
                                        </FormItem>
                                    </Form>
                                </div>
                                
                                <template v-if="examines.info.state == 2">
                                    <Alert v-for="(jt, jndex) in examines.reasons" :key="jndex" type="error" show-icon>
                                        {{ jt.reason }}
                                    </Alert>
                                </template>
                        </span>
                            <span v-else >
                                未开始
                            </span>
                        </template>
                </Step>
            </template>
            
        </Steps>


  </div>
</template>

<script>

import dayjs from 'dayjs';

export default {
  components: {
  },
  data() {
    return {
        formItem:{
            type:'1',
            contents:[]
        },
        examines:{
            info:{},
            reasons:[],
        },
        examineForm:{

        },
        testContents:[
            "准备审核","基础信息审核","单元测试审核","人工测试审核","集成测试审核","模拟升级测试审核"
        ],

        saveBtnText:"提交至审核",
        saveBtnIsDisabled:false,

        attachurl:"",
        filePushUpload: {
            hasUpload: false,
            hasPushCerUpload: false,
            fileUploadParams: {
                clientguid: this.$route.params.projectguid,
                userguid: localStorage.userguid
            },
            headers: {
                Authorization: localStorage.token
            },
            uploadurl: this.$axios.defaults.baseURL + "/mqms/file/upload",
            result:{},
        },
        uploadList:[],

        isDeveloper:false,
    };
  },
  methods: {
    initRuntimeRole(){
        let moduleid = this.$route.params.id || "";
        let _this = this;
        // 查询待修改的数据
        this.$http.post({
            method: "mqms/moduledist/findrequestbyid",
            params: {id : moduleid},
            success: function (data) {
                let from = data.obj;
                from.type = from.type + "";
                for (let item of data.list) {
                    item.type = item.type + "";
                }
                from.contents = data.list || [];
                _this.formItem = from;
            },
            failure(code, errMsg) {
                _this.$Message.error({
                    content:errMsg||"数据加载失败"
                })
            },
        });


        //如果是审核状态下的修改，需要查询对应的审核信息。
        this.$http.post({
            method: "mqms/moduledist/getAllReasonsByModuleid",
            params: {id : moduleid, state:'0'},
            success: function (data) {
                _this.examines = data;
                _this.attachurl = _this.$axios.defaults.baseURL + '/mqms/file/downloadwithoutcode?id='+data.info.fileguid
            },
            failure(code, errMsg) {
                _this.$Message.error({
                    content:errMsg||"审核信息加载失败"
                })
            },
        })

        let user = this.getCurrentUserInfo();
        for (let item of user.roles) {
            if (item == "developer") {
                this.isDeveloper = true;
                break;
            }
        }
    },

    saveAndProcess(){
        
        let moduleid = this.$route.params.id || "";
        let examineForm = this.examineForm;
        examineForm.file = this.filePushUpload.result;
        examineForm.id =  moduleid;
window.alert(moduleid);
        let _this = this;
        this.saveBtnIsDisabled = true;
        this.saveBtnText = "正在提交...";

        this.$http.post({
            method: "mqms/moduledist/nextsaveandexamine",
            params: examineForm,
            success: function (data) {
                _this.saveBtnIsDisabled = false;
                _this.saveBtnText = "提交至审核";
                _this.$router.push({
                    name:"formrequestdetail",
                    params:{id:moduleid},
                    query:{t:new Date().getTime()}
                })
            },
            failure(code, errMsg) {
                _this.saveBtnIsDisabled = false;
                _this.saveBtnText = "提交至审核";
                _this.$Message.error({
                    content:errMsg||"操作失败"
                })
            },
        })
    },

    handleBeforeUpload () {
        let check = this.uploadList.length < 1;
        if (!check) {
            this.$Notice.warning({
                title: '最多上传一份附件'
            });
        }
        return check;
    },
    onAttachUploadSuccess (res, file, fileList) {
        this.uploadList = fileList;
        this.filePushUpload.result = res.data;
    },
    onAttachUploadError (error) {
        this.$Notice.warning({
            title: '上传失败',
            desc:error
        });
    },
  
  },
  created() {
    this.initRuntimeRole();

  },
  mounted(){
  }
};
</script>